import React, { useEffect, useRef, useState } from 'react';
import '../assets/RivieraGreens.css';
import brochure from '../assets/rivieraGreens/Riviera-Greens-brochure.pdf'
import herovideo from '../assets/rivieraGreens/hero-riviera-video2.mp4';
import cctv from '../assets/rivieraGreens/cctv.webp';
import fensing from '../assets/rivieraGreens/fensing.webp';
import internalroad from '../assets/rivieraGreens/internalroad.webp';
import mseb from '../assets/rivieraGreens/mseb.webp';
import Renterence from '../assets/rivieraGreens/Renterence.webp';
import security from '../assets/rivieraGreens/securityCabin.webp';
import streetlight from '../assets/rivieraGreens/streetlight.webp';
import tree from '../assets/rivieraGreens/treeplantation.webp';
import water from '../assets/rivieraGreens/waterconnection.webp';
import agree from '../assets/rivieraGreens/landagreement.webp';
import RLayout from '../assets/rivieraGreens/riviera-layout.webp';
import map from '../assets/rivieraGreens/map.webp';
import Layout from '../assets/rivieraGreens/gallery/riviera-map-ss2.webp';
import g1 from '../assets/rivieraGreens/gallery/g1.webp';
import g2 from '../assets/rivieraGreens/gallery/g2.webp';
import g3 from '../assets/rivieraGreens/gallery/g3.webp';
import g4 from '../assets/rivieraGreens/gallery/g4.webp';
import gavthan from '../assets/rivieraGreens/gallery/gavthan.webp';
import ringroad from '../assets/rivieraGreens/gallery/ringroad.webp';
import siteoffice from '../assets/rivieraGreens/gallery/rsite-office.webp';
import sinhagad from '../assets/rivieraGreens/gallery/sinhagad.webp';
import torna from '../assets/rivieraGreens/gallery/torna.webp';
import waterfall from '../assets/rivieraGreens/gallery/waterfall.webp';
import tornafogg from '../assets/rivieraGreens/gallery/tornafogg.webp';
import g5 from '../assets/rivieraGreens/gallery/g5.webp';
import g6 from '../assets/rivieraGreens/gallery/g6.webp';
import gunjawani from '../assets/rivieraGreens/gallery/gunjawani.webp';
import peacock from '../assets/rivieraGreens/gallery/peacock.webp';
import banner1 from '../assets/imgs/RivieraBanners/1.webp';
import banner2 from '../assets/imgs/RivieraBanners/2.webp';
import banner3 from '../assets/imgs/RivieraBanners/3.webp';
import banner4 from '../assets/imgs/RivieraBanners/4.webp';
import Whatsapp from './Whatsapp';


export default function RivieraGreens() {


    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        city: "",
        project: "Riviera Greens"
    });

    const [success, setSuccess] = useState(false);
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch("https://www.samriddhidevelopers.in/backend/rg-leads.php", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();
            console.log(result);

            setSuccess(true);

            setTimeout(() => {
                setSuccess(false);
                rg_setShowBrochureForm(false);
            }, 2000);

            // Auto brochure download
            window.open("/brochures/riviera-greens.pdf", "_blank");

        } catch (error) {
            console.error("Error:", error);
            setSuccess(false);
        }
    };

    const [rg_showBrochureForm, rg_setShowBrochureForm] = useState(false);

    // Gallery images array (placeholders)
    const rg_gallery = [
        { src: gunjawani, alt: "Riviera Greens - View 1" },
        { src: g1, alt: "Riviera Greens - View 1" },
        { src: peacock, alt: "Riviera Greens - View 1" },
        { src: tornafogg, alt: "Riviera Greens - View 1" },
        { src: Layout, alt: "Riviera Greens - View 1" },
        { src: g2, alt: "Riviera Greens - View 2" },
        { src: g3, alt: "Riviera Greens - View 3" },
        { src: g4, alt: "Riviera Greens - View 4" },
        { src: g5, alt: "Riviera Greens - View 4" },
        { src: waterfall, alt: "Riviera Greens - View 4" },
        { src: gavthan, alt: "Gavthan View" },
        { src: ringroad, alt: "Ring Road Connectivity" },
        { src: siteoffice, alt: "Riviera Greens Site Office" },
        { src: g6, alt: "Riviera Greens Site Office" },
        { src: sinhagad, alt: "Sinhagad Fort View" },
        { src: torna, alt: "Torna Fort View" },
    ];

    const rg_amenities = [
        { title: "Grand Entrance Gate", img: Renterence, desc: "Premium designer entrance offering an impressive welcome." },
        { title: "20 ft Asphalt Internal Roads", img: internalroad, desc: "Durable, well-built roads ensuring smooth accessibility." },
        { title: "MSEB Power Supply", img: mseb, desc: "Electricity connection with complete street lighting." },
        { title: "Water Connection", img: water, desc: "Dedicated water line provided for every plot." },
        { title: "CCTV Surveillance", img: cctv, desc: "24x7 advanced monitoring across the entire property." },
        { title: "Security Cabin", img: security, desc: "Manned security point ensuring safe, controlled entry." },
        { title: "Compound Fencing", img: fensing, desc: "Perimeter fencing offering safety, privacy, and clear boundaries." },
        { title: "Fruit Tree Plantation", img: tree, desc: "Lush fruit-bearing trees enhancing greenery and estate value." },
        { title: "Clear Title", img: agree, desc: "100% clear title with proper individual sale deed." },
        { title: "Name on 7/12 Extract", img: agree, desc: "Your name legally recorded on the land’s 7/12 extract." }
    ];

    // ------------------------------
    // TWO SEPARATE MODALS
    // ------------------------------
    const [rg_isAmenityOpen, rg_setIsAmenityOpen] = useState(false);
    const [rg_amenityIndex, rg_setAmenityIndex] = useState(0);

    const [rg_isGalleryOpen, rg_setIsGalleryOpen] = useState(false);
    const [rg_galleryIndex, rg_setGalleryIndex] = useState(0);

    function rg_openAmenityModal(idx) {
        rg_setAmenityIndex(idx);
        rg_setIsAmenityOpen(true);
        document.body.style.overflow = 'hidden';
    }

    function rg_openGalleryModal(idx) {
        rg_setGalleryIndex(idx);
        rg_setIsGalleryOpen(true);
        document.body.style.overflow = 'hidden';
    }

    function rg_closeAmenityModal() {
        rg_setIsAmenityOpen(false);
        document.body.style.overflow = '';
    }

    function rg_closeGalleryModal() {
        rg_setIsGalleryOpen(false);
        document.body.style.overflow = '';
    }

    function rg_nextAmenity() { rg_setAmenityIndex(i => (i + 1) % rg_amenities.length); }
    function rg_prevAmenity() { rg_setAmenityIndex(i => (i - 1 + rg_amenities.length) % rg_amenities.length); }

    function rg_nextGallery() { rg_setGalleryIndex(i => (i + 1) % rg_gallery.length); }
    function rg_prevGallery() { rg_setGalleryIndex(i => (i - 1 + rg_gallery.length) % rg_gallery.length); }

    // Keyboard controls
    useEffect(() => {
        function rg_onKey(e) {
            if (rg_isAmenityOpen) {
                if (e.key === 'ArrowRight') rg_nextAmenity();
                if (e.key === 'ArrowLeft') rg_prevAmenity();
                if (e.key === 'Escape') rg_closeAmenityModal();
            }
            if (rg_isGalleryOpen) {
                if (e.key === 'ArrowRight') rg_nextGallery();
                if (e.key === 'ArrowLeft') rg_prevGallery();
                if (e.key === 'Escape') rg_closeGalleryModal();
            }
        }
        window.addEventListener('keydown', rg_onKey);
        return () => window.removeEventListener('keydown', rg_onKey);
    }, [rg_isAmenityOpen, rg_isGalleryOpen]);

    // ------------------------------
    // Parallax effect
    // ------------------------------
    const rg_heroRef = useRef(null);
    const rg_parallaxRef = useRef(null);

    useEffect(() => {
        let raf = null;
        function update() {
            const el = rg_parallaxRef.current;
            if (!el) return;
            const rect = el.getBoundingClientRect();
            const offset = rect.top * 0.15;
            el.style.transform = `translateY(${Math.round(offset)}px)`;
            raf = requestAnimationFrame(update);
        }
        raf = requestAnimationFrame(update);
        return () => cancelAnimationFrame(raf);
    }, []);

    // ------------------------------
    // Fade-in observer
    // ------------------------------
    useEffect(() => {
        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) entry.target.classList.add('rg-in-view');
                });
            },
            { threshold: 0.12 }
        );
        document.querySelectorAll('.rg-fade-up').forEach(el => observer.observe(el));
        return () => observer.disconnect();
    }, []);
    // ------------------------------
    // Investment carousel data
    // ------------------------------
    const rg_investItems = [
        {
            icon: '🧭',
            title: 'UNESCO World Heritage Boost – Torna Fort',
            desc: 'Torna Fort’s UNESCO recognition places Velhe on the global tourism map. Expect increased tourism, higher demand for premium homes, and long-term property appreciation.',
            list: ['Higher tourist footfall', 'Increased demand for farm stays', 'Major value appreciation for scenic plots'],
            highlight: 'Early investors gain the maximum advantage.'
        },
        {
            icon: '🛣️',
            title: 'Fast-Tracked Infrastructure Growth',
            desc: 'Government agencies are accelerating tourism and infrastructure development around Velhe.',
            list: ['Road expansion', 'Improved civic amenities', 'Better long-term connectivity'],
            highlight: 'Improved connectivity directly boosts land value.'
        },
        {
            icon: '🌄',
            title: 'Dual View Advantage — Dam + Fort',
            desc: 'Riviera Greens offers rare panoramic views of both Gunjavani Dam and Torna Fort.',
            list: ['Highly limited, premium view plots', 'Demand rises continuously for scenic second homes', 'Strong long-term capital appreciation']
        },
        {
            icon: '🏕️',
            title: 'Weekend Getaway Hotspot',
            desc: 'Velhe is a popular destination for trekking, camping, monsoon tourism, and rural retreats.',
            list: ['Thriving agritourism & eco-resorts', 'Preferred by Pune professionals for second homes', 'Post-COVID lifestyle shift → sustained demand']
        },
        {
            icon: '💹',
            title: '3–5 Year Appreciation Potential',
            desc: 'A ₹35 lakh plot today can realistically become ₹50–70 lakh in 4–5 years.',
            list: ['UNESCO boost', 'Government development', 'Weekend tourism', 'Limited scenic land'],
            highlight: 'Driven by infrastructure & limited supply.'
        }
    ];

    const [rg_currentSlide, rg_setCurrentSlide] = useState(0);
    const rg_prevSlide = () => rg_setCurrentSlide(i => (i - 1 + rg_investItems.length) % rg_investItems.length);
    const rg_nextSlide = () => rg_setCurrentSlide(i => (i + 1) % rg_investItems.length);
    const rg_goToSlide = i => rg_setCurrentSlide(i);

    // Auto-scroll every 6 seconds
    useEffect(() => {
        const interval = setInterval(rg_nextSlide, 6000);
        return () => clearInterval(interval);
    }, []);

    // ------------------------------
    // RENDER JSX
    // ------------------------------
    return (
        <main className="rg-page" aria-label="Riviera Greens - Luxury Farmhouse Project">

            {/* HERO */}
            <section className="rg-hero" ref={rg_heroRef} id="hero">
                <video
                    className="rg-hero-video"
                    src={herovideo}
                    poster={"/assets/riviera-hero-poster.webp"}
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="metadata"
                />



                <div className="rg-hero-overlay">
                    <div className="rg-hero-content rg-container">
                        <h3 className="rg-hero-title">Riviera Greens — Pune’s Most Exclusive Nature-Integrated Riverside Holiday Home Estate</h3>
                        <p className="rg-hero-sub">Premium Farmhouse Land Surrounded by Forts, Forests & Fortune.</p>
                        <div className="rg-hero-ctas">
                            <button className="rg-btn rg-btn-primary" onClick={() => {
                                document.getElementById("rg-about")
                                    .scrollIntoView({ behavior: "smooth" });
                            }}>Explore The Vision</button>
                            <button
                                className="rg-btn rg-btn-ghost"
                                onClick={() => {
                                    document.getElementById("rg-site")
                                        .scrollIntoView({ behavior: "smooth" });
                                }}
                            >
                                Download Brochure
                            </button>

                        </div>
                    </div>
                </div>
            </section>

            {/* ABOUT */}
            <section className="rg-about rg-fade-up" id="rg-about">
                <div className="rg-container rg-two-col">
                    <div className="rg-col rg-text">
                        <h2>About Riviera Greens</h2>
                        <p className="rg-lead">🌿 Riviera Greens – Dam View Farmhouse Plots in Velhe, Pune. Where Nature Meets Opportunity — 50-acre gated plotting project with breathtaking views of Gunjavani Dam & Torna Fort, just 39 km from Pune.</p>
                        <ul className="rg-accent-list">
                            <li>Premium 11,000 sq.ft plots</li>
                            <li>Scenic view</li>
                            <li>Resort-like amenities</li>
                        </ul>
                        <button className="rg-btn rg-btn-outline" onClick={() => {
                            document.getElementById("rg-gallery")
                                .scrollIntoView({ behavior: "smooth" });
                        }}>View Gallery</button>
                    </div>
                    <aside className="rg-col rg-hero-card" ref={rg_parallaxRef} aria-hidden>
                        <div className="rg-card-inner">
                            <img src={RLayout} loading="lazy" alt="Riviera Greens masterplan" loading="lazy" />
                            <div className="rg-card-caption">Layout</div>
                        </div>
                    </aside>
                </div>
            </section>

            {/* HIGHLIGHTS */}
            <section className="rg-highlights rg-fade-up" id="rg-highlights">
                <div className="rg-container">
                    <h3>Key Highlights</h3>
                    <div className="rg-grid rg-grid-4">
                        <div className="rg-icon-card">
                            <div className="rg-icon">🌄</div>
                            <h4>Dam & Fort View</h4>
                            <p>Enjoy rare panoramic views of Gunjavani Dam and the historic Torna Fort.</p>
                        </div>
                        <div className="rg-icon-card">
                            <div className="rg-icon">🏡</div>
                            <h4>50-Acre Gated Estate</h4>
                            <p>A premium farmhouse community with privacy, greenery and world-class planning.</p>
                        </div>
                        <div className="rg-icon-card">
                            <div className="rg-icon">🛠️</div>
                            <h4>Ready Infrastructure</h4>
                            <p>Asphalt roads, MSEB power, streetlights, water lines & secured entrance.</p>
                        </div>
                        <div className="rg-icon-card">
                            <div className="rg-icon">📈</div>
                            <h4>High Appreciation Zone</h4>
                            <p>UNESCO boost + tourism + connectivity ensures strong investment growth.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* AMENITIES */}
            <section className="rg-amenities rg-fade-up" id="rg-amenities">
                <div className="rg-container">
                    <h3>Luxury Amenities</h3>
                    <p className="rg-muted">A curated lifestyle — amenity design that complements quality life.</p>
                    <div className="rg-amenity-grid">
                        {rg_amenities.map((a, idx) => (
                            <div
                                key={idx}
                                className="rg-amenity-card"
                                onClick={() => rg_openAmenityModal(idx)}
                                role="button"
                                tabIndex={0}
                            >
                                <div className="rg-amenity-media">
                                    <img src={a.img} alt={a.title} loading="lazy" />
                                </div>
                                <div className="rg-amenity-info">
                                    <h4>{a.title}</h4>
                                    <p>{a.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            {/* SITE LAYOUT / MASTERPLAN */}
            <section className="rg-site-layout rg-fade-up" id="rg-site">
                <div className="rg-container rg-two-col">
                    <div className="rg-col">
                        <h3>Site Layout & Masterplan</h3>
                        <p className="rg-muted">
                            Thoughtfully designed over 50 acres, the Riviera Greens masterplan balances nature, accessibility, and premium living. Every plot is positioned to maximize views and ensure long-term value.
                        </p>
                        <ul className="rg-accent-list">
                            <li>Clear zoning with well-planned plot divisions</li>
                            <li>Perfect alignment for dam & fort-facing views</li>
                            <li>20 ft asphalt internal road network across the estate</li>
                            <li>Dedicated water connection & MSEB power layout</li>
                            <li>Strategically located security points and entrance plaza</li>
                            <li>Green pockets, plantation zones & natural contours preserved</li>
                        </ul>
                        <p>
                            With infrastructure already underway and all legal documentation in place, this layout is crafted for seamless development — whether you plan to build a weekend home, a retreat villa, or hold it as a high-growth investment asset.
                        </p>
                        <button className="rg-btn rg-btn-primary" onClick={() => rg_setShowBrochureForm(true)}>
                            Download Brochure (PDF)
                        </button>
                    </div>
                    <div className="rg-col rg-img-holder">
                        <img src={RLayout} alt="Riviera Greens Masterplan" loading="lazy" />
                    </div>
                </div>
            </section>

            {/* LOCATION */}
            <section className="rg-location rg-fade-up" id="rg-location">
                <div className="rg-container">
                    <h3>Location Advantages</h3>
                    <div className="rg-location-grid">
                        <ul className="rg-bullets">
                            <li>Just 38 km from Pune.</li>
                            <li>Alongside State Highway 65.</li>
                            <li>Close to proposed ring road & improved highway connectivity.</li>
                            <li>700m from Velhe Gaothan</li>
                            <li>1.5 km from Bus Stand</li>
                            <li>2 km from Petrol Pump & College</li>
                            <li>24x7 Hospital, Police Station, Market, ATM, Resorts, Hotels</li>
                            <li>All Key Government Offices – Just Minutes Away</li>
                        </ul>
                        <div className="rg-map-placeholder">
                            <div className="rg-map-embed-container">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3788.082156825262!2d73.62359797440965!3d18.297850675941145!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc29b9e3ce045a5%3A0x29ac0e87d0f03b59!2sRiviera%20Greens%20by%20Samriddhi%20Group!5e0!3m2!1sen!2sin!4v1764493215336!5m2!1sen!2sin"
                                    width="100%"
                                    height="450"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* INVESTMENT CAROUSEL */}
            <section className="rg-investment-carousel rg-fade-up" id="rg-investment">
                <div className="rg-container">
                    <h3>Why Invest in Riviera Greens?</h3>
                    <div className="rg-carousel-wrapper">
                        {/* Carousel slides */}
                        <div className="rg-carousel-track" style={{ transform: `translateX(-${rg_currentSlide * 100}%)` }}>
                            {rg_investItems.map((item, idx) => (
                                <div className="rg-carousel-slide" key={idx}>
                                    <h4>{item.icon} {item.title}</h4>
                                    <p>{item.desc}</p>
                                    {item.list && (
                                        <ul>
                                            {item.list.map((li, i) => <li key={i}>{li}</li>)}
                                        </ul>
                                    )}
                                    {item.highlight && <p className="rg-highlight">{item.highlight}</p>}
                                </div>
                            ))}
                        </div>

                        {/* Prev / Next buttons */}
                        <button className="rg-carousel-btn rg-prev" onClick={rg_prevSlide}>‹</button>
                        <button className="rg-carousel-btn rg-next" onClick={rg_nextSlide}>›</button>

                        {/* Indicators */}
                        <div className="rg-carousel-indicators">
                            {rg_investItems.map((_, i) => (
                                <button
                                    key={i}
                                    className={`rg-indicator ${rg_currentSlide === i ? 'active' : ''}`}
                                    onClick={() => rg_goToSlide(i)}
                                    aria-label={`Go to slide ${i + 1}`}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* GALLERY */}
            <section className="rg-gallery rg-fade-up" id="rg-gallery">
                <div className="rg-container">
                    <h3>Beauty of Riviera Greens</h3>
                    <div className="rg-gallery-grid">
                        {rg_gallery.map((g, i) => (
                            <button key={i} className="rg-gallery-item" onClick={() => rg_openGalleryModal(i)} aria-label={`Open image ${i + 1}`}>
                                <img src={g.src} alt={g.alt} loading="lazy" />
                            </button>
                        ))}
                    </div>
                </div>
            </section>
            {/* AMENITY MODAL */}
            {rg_isAmenityOpen && (
                <div className="rg-modal" role="dialog" aria-modal="true" aria-label="Amenity viewer">
                    <button className="rg-modal-close" onClick={rg_closeAmenityModal}>✕</button>
                    <button className="rg-modal-prev" onClick={rg_prevAmenity}>‹</button>
                    <div className="rg-modal-content">
                        <img src={rg_amenities[rg_amenityIndex].img} alt={rg_amenities[rg_amenityIndex].title} />
                        <div className="rg-meta">{rg_amenities[rg_amenityIndex].title}</div>
                    </div>
                    <button className="rg-modal-next" onClick={rg_nextAmenity}>›</button>
                </div>
            )}

            {/* GALLERY MODAL */}
            {rg_isGalleryOpen && (
                <div className="rg-modal" role="dialog" aria-modal="true" aria-label="Image viewer">
                    <button className="rg-modal-close" onClick={rg_closeGalleryModal}>✕</button>
                    <button className="rg-modal-prev" onClick={rg_prevGallery}>‹</button>
                    <div className="rg-modal-content">
                        <img src={rg_gallery[rg_galleryIndex].src} loading="lazy" alt={rg_gallery[rg_galleryIndex].alt} />
                        <div className="rg-meta">{rg_gallery[rg_galleryIndex].alt}</div>
                    </div>
                    <button className="rg-modal-next" onClick={rg_nextGallery}>›</button>
                </div>
            )}

            {/* CTA FOOTER */}
            <section className="rg-cta-footer rg-fade-up">
                <div className="rg-container">
                    <div className="rg-cta-inner">
                        <div>
                            <h3>Be part of Riviera Greens</h3>
                            <p className="rg-muted">Limited plots. Reserved for buyers who value space, privacy and generational returns.</p>
                        </div>
                        <div className="rg-cta-actions">
                            <a className="rg-btn rg-btn-primary" href="tel:+919730020099">Book a Site Visit</a>
                            <a className="rg-btn rg-btn-ghost" href="tel:+919730020099">Contact Sales</a>
                        </div>
                    </div>
                </div>
            </section>

            {/* BROCHURE FORM POPUP */}
            {rg_showBrochureForm && (
                <div className="rg-popup-overlay">
                    <div className="rg-popup">
                        <button className="rg-close" onClick={() => rg_setShowBrochureForm(false)}>✕</button>

                        <h3>Download Brochure</h3>
                        <p className="rg-note">Please fill your details to proceed</p>

                        <form className="rg-form" onSubmit={handleSubmit}>
                            <input
                                type="text"
                                name="name"
                                placeholder="Your Name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                            <input
                                type="tel"
                                name="phone"
                                placeholder="Phone Number"
                                value={formData.phone}
                                onChange={handleChange}
                                required
                            />
                            <input
                                type="text"
                                name="city"
                                placeholder="City"
                                value={formData.city}
                                onChange={handleChange}
                                required
                            />

                            <input type="hidden" name="project" value="Riviera Greens" />

                            <button className="rg-btn rg-btn-primary" type="submit">
                                Download Now
                            </button>

                            {success && <p className="success-text">Thank you! Download starting...</p>}
                        </form>

                    </div>
                </div>
            )}
            <Whatsapp />
        </main>
    );
}
